function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, $hooks, Array, JSON, Object, String, allowSmartHub, categories, createProjectError, createProjectModalOpen, createProjectName, createProjectSelectedOrgId, currentCategoryName, currentProject, currentReportName, errorAlertMsg, inviteModalOrgs, isAtProjectMax, isInviteModalOpen, navigator, omnisearchOpen, orgData, projectFeatureFlags, projectId, projectMenuWorkspaces, projectRole, projects, requestAnimationFrame, selectedCategory, showNewProjectInput, showProjectLimitUpsell, smartHubMenuOpen, toasts, utcOffset, workspaceId) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const displayNavigationOptions = !(currentReportName === 'setup' || currentReportName === 'workspaces');
    const isFestiveMode = false; // comes through seasonally, once a quarter;
    return {
      value: (h("div", {
        "class": {
          'mp-chrome-header-hidden': $attr(`hidden`)
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": Object.assign({}, {
            'mp-chrome-header-festive-mode': isFestiveMode
          }, {
            'mp-chrome-header-row-primary': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((isFestiveMode) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-festive-mode-header-anim"));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-chrome-header-inner': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((projectId) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-chrome-header-left': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-chrome-project-menu-container': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  const displayWorkspaceSelection = projectMenuWorkspaces.length >= 1;;
                  __jade_nodes = __jade_nodes.concat(h("mp-select", {
                    "attrs": {
                      'search-placeholder': displayWorkspaceSelection ? `Search workspaces` : `Search projects`,
                      'menu-width': 300,
                      'menu-height': 400,
                      'back-button': displayWorkspaceSelection,
                      'header-title': displayWorkspaceSelection ? `Workspaces (${projectMenuWorkspaces.length})` : `Projects (${projects.length})`,
                    },
                    "props": {
                      sectionsFn: $helpers.projectMenuSections
                    },
                    "on": {
                      backClick: $helpers.selectProjectMenuBackClick,
                      change: $helpers.selectProject,
                      menuChange: ev => $helpers.selectMenuChanged(`projectMenuOpen`, ev.detail.isOpen),
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "attrs": {
                        slot: `trigger`
                      },
                      "class": {
                        'mp-chrome-project-menu-btn': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      const workspace = $helpers.getCurrentWorkspace();;
                      const className = Boolean(workspace) ? `mp-chrome-project-menu-workspace-descriptor` : `mp-chrome-project-menu-project-descriptor`;;
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "attrs": {
                          class: className
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        const projectName = (currentProject && currentProject.name) || 'My new project';;
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "attrs": {
                            title: projectName
                          },
                          "class": {
                            'mp-chrome-project-menu-project': true
                          },
                        }, [__vjadeSafeCode(projectName)]));
                        __jade_nodes = __jade_nodes.concat((workspace) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'mp-chrome-project-menu-workspace': true
                            },
                          }, [__vjadeSafeCode(workspace.name)]));;
                          return __jade_nodes
                        }).call(this)) : ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'mp-chrome-project-menu-role': true
                            },
                          }, [__vjadeSafeCode(projectRole)]));;
                          return __jade_nodes
                        }).call(this)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                        "attrs": {
                          icon: 'caret-down'
                        },
                      }));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat((displayWorkspaceSelection) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(($helpers.getUserHasCreateWorkspacePermission()) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "attrs": {
                            slot: `footer`
                          },
                          "class": {
                            'mp-chrome-project-menu-add': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
                            "attrs": {
                              color: 'grey'
                            },
                            "on": {
                              click: $helpers.handleCreateWorkspaceBtnClick
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'mp-chrome-project-menu-button-bar-text': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("Create Workspace");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this)) : ((function() {
                      var __jade_nodes = []; /*  do not show add project dialog for org members unless they have perms */
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "attrs": {
                          slot: `footer`
                        },
                        "class": {
                          'mp-chrome-project-menu-add': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((orgData.length && (!orgData[0].id || $helpers.getOrgsWithCreateProjectPermission().length)) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat((showNewProjectInput) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-input-group", {
                              "attrs": {
                                label: 'Create',
                                placeholder: 'Name your new project...',
                              },
                              "hook": {
                                insert: vnode => requestAnimationFrame(() => vnode.elm.focus())
                              },
                              "on": {
                                input: $helpers.updateCreateProjectName,
                                submit: $helpers.clickedCreate,
                              },
                            }));;
                            return __jade_nodes
                          }).call(this)) : ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
                              "attrs": {
                                color: 'grey'
                              },
                              "on": {
                                click: isAtProjectMax ? $helpers.showProjectLimitUpsell : $helpers.clickedCreateProject
                              },
                              "class": {
                                'mp-chrome-project-menu-project-max': isAtProjectMax
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'mp-chrome-project-menu-button-bar-text': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat("Create Project");;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));
                            __jade_nodes = __jade_nodes.concat((isAtProjectMax) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("a", {
                                "on": {
                                  click: $helpers.showProjectLimitUpsell
                                },
                                "class": {
                                  'mp-chrome-project-menu-upsell-icon': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                  "attrs": {
                                    icon: 'lightning-bolt'
                                  },
                                }));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : undefined);;
                            return __jade_nodes
                          }).call(this)));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat((displayNavigationOptions && projectId) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-chrome-header-center': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-chrome-categories-container': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("a", {
                    "attrs": {
                      href: $helpers.getReportUrl('dashboards', {
                        projectId,
                        workspaceId
                      }),
                      isActiveCategory: `dashboards` === currentReportName,
                    },
                    "class": Object.assign({}, {
                      'mp-chrome-categories-category-selected': `dashboards` === currentReportName
                    }, {
                      'mp-chrome-categories-category': true
                    }),
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'mp-chrome-categories-label-container': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-chrome-categories-label': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Dashboards");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat((function() {
                    var $$obj = (categories);
                    var $$eachNodes;
                    var $$iterated = false;
                    if (Array.isArray($$obj)) {
                      $$eachNodes = $$obj.reduce(function($$eachNodes, cat, catName) {
                        $$iterated = true;
                        return $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          const attrs = {};
                          const isActiveCategory = catName === selectedCategory;
                          __jade_nodes = __jade_nodes.concat((cat.endpoint) ? ((function() {
                            var __jade_nodes = [];
                            attrs.href = $helpers.getReportUrl(cat.endpoint, {
                              projectId,
                              workspaceId
                            });;;
                            return __jade_nodes
                          }).call(this)) : undefined);
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "attrs": attrs,
                            "on": {
                              click: ev => $helpers.toggleSelectedCategory(catName),
                            },
                            "class": Object.assign({}, {
                              'mp-chrome-categories-category-selected': catName === currentCategoryName,
                              [`mp-chrome-categories-${cat.icon}`]: true
                            }, {
                              'mp-chrome-categories-category': true
                            }),
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'mp-chrome-categories-label-container': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'mp-chrome-categories-label': true
                                },
                              }, [__vjadeSafeCode(cat.label)]));
                              const reportsMenuOpen = cat.reports && isActiveCategory;
                              __jade_nodes = __jade_nodes.concat((reportsMenuOpen) ? ((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("mp-reports-menu", {
                                  "hook": {
                                    remove: $hooks.delayedAttrRemove(`open`, `false`)
                                  },
                                  "attrs": {
                                    'project-id': projectId,
                                    'two-column': !!cat.twoColumn,
                                    reports: JSON.stringify(cat.reports),
                                    order: JSON.stringify(cat.order || Object.keys(cat.reports)),
                                    open: true,
                                    'workspace-id': workspaceId,
                                  },
                                }));;
                                return __jade_nodes
                              }).call(this)) : undefined);;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                      }, []);
                    } else {
                      $$eachNodes = [];
                      for (var $$objKey in $$obj) {
                        (function() {
                          var catName = $$objKey;
                          if ($$obj.hasOwnProperty(catName)) {
                            $$iterated = true;
                            var cat = $$obj[catName];
                            $$eachNodes = $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              const attrs = {};
                              const isActiveCategory = catName === selectedCategory;
                              __jade_nodes = __jade_nodes.concat((cat.endpoint) ? ((function() {
                                var __jade_nodes = [];
                                attrs.href = $helpers.getReportUrl(cat.endpoint, {
                                  projectId,
                                  workspaceId
                                });;;
                                return __jade_nodes
                              }).call(this)) : undefined);
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "attrs": attrs,
                                "on": {
                                  click: ev => $helpers.toggleSelectedCategory(catName),
                                },
                                "class": Object.assign({}, {
                                  'mp-chrome-categories-category-selected': catName === currentCategoryName,
                                  [`mp-chrome-categories-${cat.icon}`]: true
                                }, {
                                  'mp-chrome-categories-category': true
                                }),
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'mp-chrome-categories-label-container': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'mp-chrome-categories-label': true
                                    },
                                  }, [__vjadeSafeCode(cat.label)]));
                                  const reportsMenuOpen = cat.reports && isActiveCategory;
                                  __jade_nodes = __jade_nodes.concat((reportsMenuOpen) ? ((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("mp-reports-menu", {
                                      "hook": {
                                        remove: $hooks.delayedAttrRemove(`open`, `false`)
                                      },
                                      "attrs": {
                                        'project-id': projectId,
                                        'two-column': !!cat.twoColumn,
                                        reports: JSON.stringify(cat.reports),
                                        order: JSON.stringify(cat.order || Object.keys(cat.reports)),
                                        open: true,
                                        'workspace-id': workspaceId,
                                      },
                                    }));;
                                    return __jade_nodes
                                  }).call(this)) : undefined);;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this));
                          }
                        })();
                      }
                    }

                    return $$eachNodes;
                  })());;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-chrome-header-right': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((displayNavigationOptions) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "on": {
                    click: $helpers.handleOmnisearchToggle
                  },
                  "class": {
                    'mp-chrome-header-trigger-container': true,
                    'mp-chrome-header-trigger-btn': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": {
                      icon: 'search'
                    },
                  }));
                  const modifier = navigator.appVersion.includes("Mac") ? `opt` : `alt`;;
                  __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                    "attrs": {
                      'placement': `bottom`
                    },
                    "style": {
                      display: $helpers.allMenusClosed() ? `` : `none`
                    },
                  }, [__vjadeSafeCode(`Search (${modifier}+f)`)]));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat((displayNavigationOptions && projectId) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((!projectFeatureFlags.has(`hide_menu_apps`)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-chrome-header-trigger-container': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-select", {
                      "attrs": {
                        searchable: true,
                        'search-threshold': 10,
                        'menu-width': 300,
                        'menu-height': 400,
                      },
                      "props": {
                        sectionsFn: $helpers.getApplicationsMenuSections,
                      },
                      "on": {
                        change: $helpers.menuItemSelected,
                        menuChange: ev => $helpers.selectMenuChanged(`applicationsMenuOpen`, ev.detail.isOpen),
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "attrs": {
                          slot: `trigger`
                        },
                        "class": {
                          'mp-chrome-header-trigger-btn': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                          "attrs": {
                            icon: 'applications'
                          },
                        }));
                        __jade_nodes = __jade_nodes.concat(($helpers.allMenusClosed()) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                            "attrs": {
                              'placement': `bottom`
                            },
                          }, [__vjadeSafeCode(`Applications`)]));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat((allowSmartHub) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-chrome-header-trigger-container': true,
                      'mp-chrome-header-trigger-btn': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-smart-hub-global", {
                      "attrs": {
                        open: smartHubMenuOpen,
                        'project-id': projectId || ``,
                        'utc-offset': utcOffset || ``,
                        'workspace-id': workspaceId || ``,
                      },
                      "on": {
                        change: e => $helpers.menuChanged(e.detail.state, `smartHub`),
                      },
                    }));
                    __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                      "attrs": {
                        'placement': `bottom`
                      },
                      "style": {
                        display: $helpers.allMenusClosed() ? `` : `none`
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("All Alerts");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-chrome-header-trigger-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-select", {
                  "attrs": {
                    'menu-width': 280,
                    'menu-height': 480,
                  },
                  "props": {
                    sectionsFn: $helpers.getSettingsMenuSections
                  },
                  "on": {
                    change: $helpers.menuItemSelected,
                    menuChange: ev => $helpers.selectMenuChanged(`setupMenuOpen`, ev.detail.isOpen),
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "attrs": {
                      slot: `trigger`
                    },
                    "class": {
                      'mp-chrome-header-trigger-btn': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                      "attrs": {
                        icon: 'settings'
                      },
                    }));
                    __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                      "attrs": {
                        'placement': `bottom`
                      },
                      "style": {
                        display: $helpers.allMenusClosed() ? `` : `none`
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Settings");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        const cat = categories[currentCategoryName] || {};
        const reports = cat.reports;
        __jade_nodes = __jade_nodes.concat((reports) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-chrome-header-row-secondary': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-chrome-header-row-secondary-inner': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-chrome-reports-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((function() {
                  var $$obj = (reports);
                  var $$eachNodes;
                  var $$iterated = false;
                  if (Array.isArray($$obj)) {
                    $$eachNodes = $$obj.reduce(function($$eachNodes, report, $index) {
                      $$iterated = true;
                      return $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("a", {
                          "attrs": {
                            href: $helpers.getReportUrl(report.endpoint, {
                              projectId,
                              workspaceId
                            })
                          },
                          "class": Object.assign({}, {
                            'mp-chrome-reports-report-selected': report.name === currentReportName
                          }, {
                            'mp-chrome-reports-report': true
                          }),
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat((report.gated) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                              "attrs": {
                                icon: `lightning-bolt`
                              },
                            }));;
                            return __jade_nodes
                          }).call(this)) : undefined);
                          __jade_nodes = __jade_nodes.concat("" + (report.label) + "");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this));
                    }, []);
                  } else {
                    $$eachNodes = [];
                    for (var $$objKey in $$obj) {
                      (function() {
                        var $index = $$objKey;
                        if ($$obj.hasOwnProperty($index)) {
                          $$iterated = true;
                          var report = $$obj[$index];
                          $$eachNodes = $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("a", {
                              "attrs": {
                                href: $helpers.getReportUrl(report.endpoint, {
                                  projectId,
                                  workspaceId
                                })
                              },
                              "class": Object.assign({}, {
                                'mp-chrome-reports-report-selected': report.name === currentReportName
                              }, {
                                'mp-chrome-reports-report': true
                              }),
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat((report.gated) ? ((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                  "attrs": {
                                    icon: `lightning-bolt`
                                  },
                                }));;
                                return __jade_nodes
                              }).call(this)) : undefined);
                              __jade_nodes = __jade_nodes.concat("" + (report.label) + "");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this));
                        }
                      })();
                    }
                  }

                  return $$eachNodes;
                })());;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined); /*  toasts, modals, alerts and drawers */
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-chrome-toasts': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((function() {
            var $$obj = (toasts);
            var $$eachNodes;
            var $$iterated = false;
            if (Array.isArray($$obj)) {
              $$eachNodes = $$obj.reduce(function($$eachNodes, toast, $index) {
                $$iterated = true;
                return $$eachNodes.concat((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-toast", {
                    "key": toast.id,
                    "dataset": {
                      id: toast.id
                    },
                    "on": {
                      close: () => $helpers.closeToast(toast),
                      action: toast.cta ? $helpers.handleToastCtaAction : null,
                    },
                    "attrs": {
                      cta: toast.cta || '',
                      hide: toast.hide,
                      'is-error': toast[`is-error`],
                    },
                  }, [__vjadeSafeCode(toast.message)]));;
                  return __jade_nodes
                }).call(this));
              }, []);
            } else {
              $$eachNodes = [];
              for (var $$objKey in $$obj) {
                (function() {
                  var $index = $$objKey;
                  if ($$obj.hasOwnProperty($index)) {
                    $$iterated = true;
                    var toast = $$obj[$index];
                    $$eachNodes = $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-toast", {
                        "key": toast.id,
                        "dataset": {
                          id: toast.id
                        },
                        "on": {
                          close: () => $helpers.closeToast(toast),
                          action: toast.cta ? $helpers.handleToastCtaAction : null,
                        },
                        "attrs": {
                          cta: toast.cta || '',
                          hide: toast.hide,
                          'is-error': toast[`is-error`],
                        },
                      }, [__vjadeSafeCode(toast.message)]));;
                      return __jade_nodes
                    }).call(this));
                  }
                })();
              }
            }

            return $$eachNodes;
          })());;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat((orgData.length && createProjectModalOpen) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-modal", {
            "hook": {
              remove: $hooks.delayedAttrRemove(`open`, `false`)
            },
            "attrs": {
              open: true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-content-header': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Create Project");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-content-body': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-input", {
                "attrs": {
                  type: `text`,
                  placeholder: `e.g. Production Analytics`,
                  label: `Project Name`
                },
                "props": {
                  value: createProjectName
                },
                "on": {
                  input: $helpers.updateCreateProjectName
                },
                "hook": {
                  insert: ({
                    elm
                  }) => requestAnimationFrame(() => elm.focus())
                },
                "class": {
                  'mp-chrome-create-project-modal-input': true
                },
              }));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-chrome-create-project-modal-label': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Select Organization");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-chrome-create-project-modal-radio-button-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((function() {
                  var $$obj = (orgData);
                  var $$eachNodes;
                  var $$iterated = false;
                  if (Array.isArray($$obj)) {
                    $$eachNodes = $$obj.reduce(function($$eachNodes, org, $index) {
                      $$iterated = true;
                      return $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        const disabled = !$helpers.orgHasPerm(org, `create_project`);
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'button-wrap': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-radio-button", {
                            "attrs": {
                              selected: createProjectSelectedOrgId === org.id
                            },
                            "on": {
                              click: () => !disabled && $helpers.selectOrg(org.id)
                            },
                            "class": {
                              'mp-chrome-create-project-modal-disabled': disabled
                            },
                          }, [__vjadeSafeCode(org.name)]));
                          __jade_nodes = __jade_nodes.concat((disabled) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                              "attrs": {
                                placement: `right`
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("You do not have permission to create projects in this organization");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : undefined);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this));
                    }, []);
                  } else {
                    $$eachNodes = [];
                    for (var $$objKey in $$obj) {
                      (function() {
                        var $index = $$objKey;
                        if ($$obj.hasOwnProperty($index)) {
                          $$iterated = true;
                          var org = $$obj[$index];
                          $$eachNodes = $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            const disabled = !$helpers.orgHasPerm(org, `create_project`);
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'button-wrap': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-radio-button", {
                                "attrs": {
                                  selected: createProjectSelectedOrgId === org.id
                                },
                                "on": {
                                  click: () => !disabled && $helpers.selectOrg(org.id)
                                },
                                "class": {
                                  'mp-chrome-create-project-modal-disabled': disabled
                                },
                              }, [__vjadeSafeCode(org.name)]));
                              __jade_nodes = __jade_nodes.concat((disabled) ? ((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                  "attrs": {
                                    placement: `right`
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat("You do not have permission to create projects in this organization");;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this)) : undefined);;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this));
                        }
                      })();
                    }
                  }

                  return $$eachNodes;
                })());;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-content-footer': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": {
                  size: `small`,
                  theme: `primary`
                },
                "on": {
                  click: $helpers.clickedCreate
                },
                "class": {
                  'mp-modal-button': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Create");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": {
                  size: `small`,
                  theme: `tertiary`
                },
                "on": {
                  click: $helpers.clickedCancel
                },
                "class": {
                  'mp-modal-button': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Cancel");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat((isInviteModalOpen) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-invite-users-modal", {
            "hook": {
              remove: $hooks.delayedAttrRemove(`open`, `false`)
            },
            "attrs": {
              open: true,
            },
            "props": {
              orgs: inviteModalOrgs,
            },
            "on": {
              save: $helpers.closeInviteModal,
              cancel: $helpers.closeInviteModal,
              notify: $helpers.handleNotify,
              error: $helpers.handleError,
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined); /*  generic error alert */
        __jade_nodes = __jade_nodes.concat((errorAlertMsg) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-alert", {
            "hook": {
              remove: $hooks.delayedAttrRemove(`open`, `false`)
            },
            "attrs": {
              closeable: true,
              open: true
            },
            "on": {
              change: $helpers.handleAlertChange
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'text': true
                },
              }, [__vjadeSafeCode(errorAlertMsg)]));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined); /*  special case for project error alert */
        __jade_nodes = __jade_nodes.concat((createProjectError) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-alert", {
            "hook": {
              remove: $hooks.delayedAttrRemove(`open`, `false`)
            },
            "attrs": {
              closeable: true,
              'large-icon': true,
              open: true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Failed to create new project");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Error: " + (createProjectError) + "");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat((showProjectLimitUpsell) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-upsell-popup", {
            "hook": {
              remove: $hooks.delayedAttrRemove(`open`, `false`)
            },
            "attrs": {
              open: true,
              feature: `projects`
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat((omnisearchOpen) ? ((function() {
          var __jade_nodes = [];
          const currentWorkspace = $helpers.getCurrentWorkspace();;
          __jade_nodes = __jade_nodes.concat(h("mp-omnisearch", {
            "hook": {
              remove: $hooks.delayedAttrRemove(`open`, `false`)
            },
            "attrs": {
              'open': omnisearchOpen,
              'project-id': currentProject.id,
              'project-name': currentProject.name,
              'workspace-id': currentWorkspace ? currentWorkspace.id : 0,
              'workspace-name': currentWorkspace ? currentWorkspace.name : '',
            },
            "on": {
              close: $helpers.handleOmnisearchClose,
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "$hooks" in locals ? locals.$hooks : typeof $hooks !== "undefined" ? $hooks : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "allowSmartHub" in locals ? locals.allowSmartHub : typeof allowSmartHub !== "undefined" ? allowSmartHub : undefined, "categories" in locals ? locals.categories : typeof categories !== "undefined" ? categories : undefined, "createProjectError" in locals ? locals.createProjectError : typeof createProjectError !== "undefined" ? createProjectError : undefined, "createProjectModalOpen" in locals ? locals.createProjectModalOpen : typeof createProjectModalOpen !== "undefined" ? createProjectModalOpen : undefined, "createProjectName" in locals ? locals.createProjectName : typeof createProjectName !== "undefined" ? createProjectName : undefined, "createProjectSelectedOrgId" in locals ? locals.createProjectSelectedOrgId : typeof createProjectSelectedOrgId !== "undefined" ? createProjectSelectedOrgId : undefined, "currentCategoryName" in locals ? locals.currentCategoryName : typeof currentCategoryName !== "undefined" ? currentCategoryName : undefined, "currentProject" in locals ? locals.currentProject : typeof currentProject !== "undefined" ? currentProject : undefined, "currentReportName" in locals ? locals.currentReportName : typeof currentReportName !== "undefined" ? currentReportName : undefined, "errorAlertMsg" in locals ? locals.errorAlertMsg : typeof errorAlertMsg !== "undefined" ? errorAlertMsg : undefined, "inviteModalOrgs" in locals ? locals.inviteModalOrgs : typeof inviteModalOrgs !== "undefined" ? inviteModalOrgs : undefined, "isAtProjectMax" in locals ? locals.isAtProjectMax : typeof isAtProjectMax !== "undefined" ? isAtProjectMax : undefined, "isInviteModalOpen" in locals ? locals.isInviteModalOpen : typeof isInviteModalOpen !== "undefined" ? isInviteModalOpen : undefined, "navigator" in locals ? locals.navigator : typeof navigator !== "undefined" ? navigator : undefined, "omnisearchOpen" in locals ? locals.omnisearchOpen : typeof omnisearchOpen !== "undefined" ? omnisearchOpen : undefined, "orgData" in locals ? locals.orgData : typeof orgData !== "undefined" ? orgData : undefined, "projectFeatureFlags" in locals ? locals.projectFeatureFlags : typeof projectFeatureFlags !== "undefined" ? projectFeatureFlags : undefined, "projectId" in locals ? locals.projectId : typeof projectId !== "undefined" ? projectId : undefined, "projectMenuWorkspaces" in locals ? locals.projectMenuWorkspaces : typeof projectMenuWorkspaces !== "undefined" ? projectMenuWorkspaces : undefined, "projectRole" in locals ? locals.projectRole : typeof projectRole !== "undefined" ? projectRole : undefined, "projects" in locals ? locals.projects : typeof projects !== "undefined" ? projects : undefined, "requestAnimationFrame" in locals ? locals.requestAnimationFrame : typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : undefined, "selectedCategory" in locals ? locals.selectedCategory : typeof selectedCategory !== "undefined" ? selectedCategory : undefined, "showNewProjectInput" in locals ? locals.showNewProjectInput : typeof showNewProjectInput !== "undefined" ? showNewProjectInput : undefined, "showProjectLimitUpsell" in locals ? locals.showProjectLimitUpsell : typeof showProjectLimitUpsell !== "undefined" ? showProjectLimitUpsell : undefined, "smartHubMenuOpen" in locals ? locals.smartHubMenuOpen : typeof smartHubMenuOpen !== "undefined" ? smartHubMenuOpen : undefined, "toasts" in locals ? locals.toasts : typeof toasts !== "undefined" ? toasts : undefined, "utcOffset" in locals ? locals.utcOffset : typeof utcOffset !== "undefined" ? utcOffset : undefined, "workspaceId" in locals ? locals.workspaceId : typeof workspaceId !== "undefined" ? workspaceId : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;